export default {
  disclaimer: "These are settled transactions. May have pending charges.",
  title: "Billing History"
};
